<template>
  <section class="to-examine">
    <!--头部开始-->
    <header class="head">
      <i class="icon-notice"></i>
    </header>
    <!--头部结束-->

    <h3 class="apply-result">审核中</h3>

    <p class="to-examine-desc">您的地图MOD已经在审核中，请耐心等待审核结果，审核通过将会邮件通知您</p>

    <div class="content">
      <ul class="step-list clearfix">
        <li v-for="(item, index) in stepList" class="item" :class="mapStatus > index ? 'active' : ''">
          <span class="text">{{ item }}</span>
        </li>
      </ul>
    </div>

    <!--操作开始-->
    <div class="handle">
      <router-link class="go-home item" to="/home">返回开发者首页</router-link>
      <a class="revoke item" href="javascript: void(0)" @click="revokeFn">撤销审核</a>
    </div>
    <!--操作结束-->

    <!--遮罩层开始-->
    <div class="confirm-mask-wrap" onselectstart="return false">
      <transition name="fade">
        <div class="confirm-mask" v-show="show">
          <div class="confirm-mask-content" ref="confirmMaskContent">
            <div v-show="!revokeFlag">
              <p class="desc">您将撤销您的审核，请确认您的操作</p>

              <div class="btn-wrap">
                <a class="btn cancel" href="javascript: void(0)" @click="closeMaskFn">取消</a>
                <a class="btn revoke" href="javascript: void(0)" @click="revokeConfirmFn">撤销审核</a>
              </div>
            </div>

            <div v-show="revokeFlag">
              <p class="desc">撤销成功，{{ num }} s 后返回开发者首页</p>

              <div class="btn-wrap">
                <a class="btn cancel" href="javascript: void(0)" @click="goHomeFn">确定</a>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <!--遮罩层结束-->

    <!--使用提示层-->
    <v-basic-mask :show="tipsShow" @closeMaskEv="closeMaskEvFn">
      <span slot="desc">{{ tipsText }}</span>
    </v-basic-mask>
  </section>
</template>

<script type="text/ecmascript-6">
  // ajax 请求插件
  import Axios from 'axios'
  // 引入 cookie插件
  import VueCookie from 'vue-cookie'
  // 确认弹出层组件
  import confirmMask from 'components/confirmMask/confirmMask'
  // 用户信息相关操作
  import {delUserCookie} from 'assets/js/user'
  // 基础弹出层组件
  import basicMask from 'components/basicMask/basicMask'
  const stepList = [
    '地图MOD制作',
    '测试区审核',
    '测试区上线',
    '正式区审核',
    '正式区上线'
  ]

  export default {
    // 审核中页面
    name: 'toExamine',
    data () {
      return {
        // 倒计时计时器
        timer: '',
        // 接口地址
        apiPath: {
          getMapInfo: '',
          revokeApply: ''
        },
        // 倒计时
        num: 3,
        // 地图id
        mapId: this.$route.params.mapId,
        // 地图进行阶段
        stage: this.$route.params.stage,
        // 审核进度 id
        mapStageId: '',
        // 审核进度
        mapStatus: '',
        // 撤销审核是否成功标志
        revokeFlag: false,
        // 进度列表
        stepList: stepList,
        // 遮罩层标记
        show: false,
        // 提示层开关
        tipsShow: false,
        // 提示信息
        tipsText: '',
        // 表单数据
        formDatas: {
          // 用户id
          userId: VueCookie.get('UserID'),
          // session id
          sessionId: VueCookie.get('SessionID')
        }
      }
    },
    created () {
      // 初始化数据
      this.init()
    },
    beforeUpdate () {
      // 遮罩层初始化
      this.$nextTick(() => {
        this.maskInit()
      })
    },
    methods: {
      init () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // 地图id
        formData.append('MapId', this.mapId)
        // 请求地图详细信息 api
        switch (this.stage) {
          // 设置开发阶段的获取地图信息接口和撤销审核申请接口
          case 'dev':
            this.apiPath.getMapInfo = '/Developer/GetMapDevInfo'
            this.apiPath.revokeApply = '/Developer/RevokeAuditDev'
            break
          // 设置测试阶段的获取地图信息接口和撤销审核申请接口
          case 'exa':
            this.apiPath.getMapInfo = '/Developer/GetMapExaInfo'
            this.apiPath.revokeApply = '/Developer/RevokeAuditExa'
            break
          // 设置正式阶段的获取地图信息接口和撤销审核申请接口
          case 'pub':
            this.apiPath.getMapInfo = '/Developer/GetMapPubInfo'
            this.apiPath.revokeApply = '/Developer/RevokeAuditPub'
            break
          default:
            console.log('开发阶段匹配错误')
        }
        Axios.post(`${this.$api.root}${this.apiPath.getMapInfo}`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                switch (this.stage) {
                  case 'dev':
                    // 审核进度 id
                    this.mapStageId = res.DevInfo.Id
                    // 获取地图审核进度
                    this.mapStatus = res.DevInfo.Status
                    break
                  case 'exa':
                    // 审核进度 id
                    this.mapStageId = res.ExaInfo.Id
                    // 获取地图审核进度
                    this.mapStatus = res.ExaInfo.Status
                    break
                  case 'pub':
                    // 审核进度 id
                    this.mapStageId = res.PubInfo.Id
                    // 获取地图审核进度
                    this.mapStatus = res.PubInfo.Status
                    break
                  default:
                    console.log('获取阶段错误')
                }
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                this.$router.push({name: 'login'})
                break
              default:
                console.log(res.Code)
                console.log(res.Msg)
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      maskInit () {
        // 获取弹出层内容
        let oConfirmMaskContent = this.$refs.confirmMaskContent
        // 计算左边边距
        let left = oConfirmMaskContent.offsetWidth / 2
        // 计算上边边距
        let top = oConfirmMaskContent.offsetHeight / 2
        // 对边距进行赋值
        oConfirmMaskContent.style.marginLeft = `${-left}px`
        oConfirmMaskContent.style.marginTop = `${-top}px`
      },
      // 关闭遮罩层
      closeMaskFn () {
        this.show = false
      },
      // 点击撤销审核，弹出弹出层
      revokeFn () {
        this.show = !this.show
      },
      // 确认撤销审核
      revokeConfirmFn () {
        // 实例化表单对象
        let formData = new FormData()
        // 将用户名添加到表单
        formData.append('UserID', this.formDatas.userId)
        // 将密码添加到表单
        formData.append('SessionID', this.formDatas.sessionId)
        // // 将审核进度 id 加入表单
        formData.append('MapStageId', this.mapStageId)
        // 请求地图详细信息 api
        Axios.post(`${this.$api.root}${this.apiPath.revokeApply}`, formData, {
          // 设置请求为表单提交
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((response) => {
          // http 请求成功
          if (response.status === 200) {
            // 获取接口数据
            let res = response.data
            switch (res.Code) {
              case 0:
                // 撤销成功，重置标志
                this.revokeFlag = true
                let _this = this
                this.timer = setInterval(function () {
                  _this.num--
                  if (_this.num === 0) {
                    clearInterval(_this.timer)
                    _this.$router.push({name: 'login'})
                  }
                }, 1000)
                break
              case 1:
                // 删除登录信息
                delUserCookie()
                // 跳转到登录页
                this.$router.push({name: 'login'})
                break
              case 2:
                // 弹出提示层
                this.tipsShow = true
                // 弹出提示信息
                this.tipsText = res.Msg
                break
              default:
                // 弹出提示层
                this.tipsShow = true
                // 弹出提示信息
                this.tipsText = res.Msg
                break
            }
          }
        }).catch((error) => {
          console.log(error)
        })
      },
      // 撤销审核成功后跳转到个人主页
      goHomeFn () {
        // 清空计时器
        clearInterval(this.timer)
        // 跳转到首页
        this.$router.push({name: 'home'})
      },
      // 关闭提示层
      closeMaskEvFn (val) {
        // 关闭弹出层
        this.tipsShow = val
        // 是否刷新页面
        if (this.refreshFlag) {
          // 重置刷新标志
          this.refreshFlag = false
          // 刷新页面
          this.$router.go(0)
        }
      }
    },
    components: {
      'v-confirm-mask': confirmMask,
      'v-basic-mask': basicMask
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "toExamine.styl";
</style>



// WEBPACK FOOTER //
// src/views/toExamine/toExamine.vue